import { Skull, Flame, Shield } from "lucide-react";

/**
 * BossPreviewCard (iter67) — single-pane modal that pops when the player
 * enters a non-boss floor immediately before a boss floor. Previews the
 * upcoming boss' HP + hit, plus a CTA toward the Forge.
 */
export default function BossPreviewCard({ open, preview, onClose, onOpenForge }) {
  if (!open || !preview) return null;

  const { name, floor, preview_hp, preview_dmg, forge_cta } = preview;

  return (
    <div
      className="fixed inset-0 z-[88] flex items-center justify-center px-4"
      style={{ background: "rgba(5,2,1,0.9)" }}
      data-testid="boss-preview-card"
    >
      <div
        className="panel p-6 sm:p-8 max-w-lg w-full relative overflow-hidden"
        style={{
          background: "radial-gradient(ellipse at top, rgba(90,20,10,0.3), rgba(10,5,3,0.98))",
          borderColor: "rgba(192,57,43,0.6)",
          boxShadow: "0 0 40px rgba(192,57,43,0.18), inset 0 0 60px rgba(0,0,0,0.6)",
        }}
      >
        <div className="flex items-center gap-2 mb-3">
          <Skull size={14} className="blood-text" />
          <span className="text-[10px] tracking-[0.45em] blood-text font-heading">A SHADOW · LOOMS</span>
        </div>

        <h2 className="font-heading text-3xl sm:text-4xl text-[#f0e6d2] italic leading-tight">
          {name}
        </h2>
        <div className="text-[11px] tracking-[0.35em] ash-text mt-2">BOSS · FLOOR {floor}</div>

        <div className="mt-5 h-px bg-gradient-to-r from-[#c0392b]/60 via-[#c0392b]/20 to-transparent" />

        <div className="mt-5 grid grid-cols-2 gap-4">
          <div className="panel p-3 bg-black/40">
            <div className="flex items-center gap-1.5 text-[10px] tracking-[0.3em] ash-text">
              <Flame size={11} className="blood-text" /> HP
            </div>
            <div className="font-heading text-2xl text-[#f0e6d2] mt-1">~{preview_hp.toLocaleString()}</div>
          </div>
          <div className="panel p-3 bg-black/40">
            <div className="flex items-center gap-1.5 text-[10px] tracking-[0.3em] ash-text">
              <Shield size={11} className="blood-text" /> HIT
            </div>
            <div className="font-heading text-2xl text-[#f0e6d2] mt-1">~{preview_dmg}</div>
          </div>
        </div>

        <p className="mt-5 font-narrative text-[#f0e6d2] italic leading-relaxed text-sm">
          {forge_cta}
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            onClick={() => { onOpenForge && onOpenForge(); onClose && onClose(); }}
            className="btn-primary flex-1"
            data-testid="boss-preview-forge-btn"
          >
            ⚒  VISIT THE FORGE
          </button>
          <button
            type="button"
            onClick={onClose}
            className="btn-glow flex-1"
            data-testid="boss-preview-descend-btn"
          >
            DESCEND ANYWAY
          </button>
        </div>
      </div>
    </div>
  );
}
